import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const UPLOAD_API_URL = 'trust/admin/trust-upload-file/'
export const uploadLoanFile = createAsyncThunk(
  'example/submitFormData',
   async ({ file, trust_name, file_password }, { getState, rejectWithValue }) => {
    try {
      // Get the token from Redux state (adjust the path as needed)
      const token = getState().auth.token;
      const formData = new FormData();
      formData.append('file', file);
    
  formData.append("file_password", JSON.stringify({
    file_password,
  }));
  formData.append("trust_name", JSON.stringify({
    trust_name,
  }));
      const response = await axios.post(UPLOAD_API_URL, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const uploadSlice = createSlice({
  name: 'upload',
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadLoanFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadLoanFile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadLoanFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null
      });
  },
});

export default uploadSlice.reducer;
